<template>
    <template v-if="detail.qrCode">
        <div class="dashboard-table-row table-row-v2 mb-3">
            <div class="dashboard-table-column text-wrap text-center d-block">
                <p>Совершая оплату вы  подтверждаете, что оплачиваете со своего счета МБанк и согласны на ручную  проверку транзакции, которая может занять до 8 часов.</p>
                <hr>
                <p>Для проведения платежа, отсканируйте QR-код в приложении банка:</p>
            </div>
        </div>
        <div class="modal-qr-image modal-qr-mkassa mb-3">
            <img :src="detail.qrCode" :alt="detail.description">
        </div>
    </template>
    <template v-if="detail.deepLink">
        <div class="dashboard-table-row table-row-v2 justify-content-center mb-3">
            <div class="dashboard-table-column text-wrap">Или откройте ссылку для оплаты в MBank:</div>
        </div>
        <a :href="detail.deepLink" class="mbank-button" target="_blank"></a>
    </template>
</template>

<script>
export default {
    props: {
        detail: Object
    }
}
</script>